<template>
	<canvas class="wifi" ref="canvas"></canvas>
</template>

<script>
export default {
	name: "IconWifi",
	props: ["wifi"],
	data: function() {
		return {
			height: 15,
			width: 0,
		};
	},
	mounted: function() {
		let canvas = this.$refs.canvas;

		const procenta = this.wifi;

		const pomer = this.height / 100*10;
		const sirka = 30;
		const mezera = 15;

		let ctx = canvas.getContext("2d");

		ctx.moveTo(0, 0);

		for (let index = 1; index <= 5; index++) {
			let procenta_index = index * 20;

			ctx.fillStyle = "#D3D3D3";

			if (procenta > procenta_index - 20) {
				ctx.fillStyle = "#808080";
			}

			ctx.fillRect(
				Math.round((sirka + mezera) * (index - 1) * pomer),
				(100 - procenta_index) * pomer,
				Math.round(sirka * pomer),
				Math.round(procenta_index * pomer)
			);
		}
	},
};
</script>

<style scoped>
canvas {
	width: 34px;
	height: 16px;
}
</style>
